<div class="type-details__header">
  <div class="type-details__header-info">
    <h2 class="type-details__title">
      {{ typeNode().label | stripPrefix: 'full' }}
    </h2>
  </div>
  <button
    tds-icon-button
    variant="tertiary"
    size="sm"
    label="Close details panel"
    aria-label="Close details panel"
    (click)="onClose()"
  >
    <tds-icon [name]="$any('close')"></tds-icon>
  </button>
</div>

<div class="type-details__content">
  @if (typeNode().properties.length > 0) {
    <h3 class="type-details__section-title">Properties</h3>
    <div class="type-details__properties">
      @for (prop of typeNode().properties; track prop) {
        <span class="type-details__property-badge">{{ prop }}</span>
      }
    </div>
  }

  @if (relationships().length > 0) {
    <h3 class="type-details__section-title">Relationships</h3>
    @for (rel of relationships(); track rel.relationshipType) {
      <div class="type-details__relationship">
        <span class="type-details__relationship-type">{{
          rel.relationshipType
        }}</span>
        <span class="type-details__relationship-arrow">→</span>
        <span class="type-details__relationship-target">{{
          rel.targetAssetType | stripPrefix
        }}</span>
      </div>
    }
  }

  @if (assets().length > 0) {
    <h3 class="type-details__section-title">
      Instances ({{ assets().length }})
    </h3>
    <ul class="type-details__asset-list">
      @for (asset of assets(); track asset.id) {
        <li>
          <button
            class="type-details__asset-link"
            (click)="onNavigate(asset.id)"
          >
            <span class="type-details__asset-name">{{ asset.name }}</span>
          </button>
        </li>
      }
    </ul>
  }
</div>
